<template>
    <tag
        :class="classes"
        @click="hitApi"
        :disabled="internalDisabled"
        :is="tag"
    >
        <i v-if="iconClass" :class="iconClass"></i> {{ text }}
    </tag>
</template>

<script>
import Tag from "../Tag.vue";
export default {
    name: 'ApiPostButton',

    components: {
        Tag,
    },

    props: {
        classes: {
            type: String,
            required: false,
        },
        config: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        confirm: {
            type: String,
            required: false,
        },
        disabled: {
            default: false,
            required: false,
            type: Boolean,
        },
        endPoint: {
            type: String,
            required: true,
        },
        iconClass: {
            required: false,
            type: String,
        },
        method: {
            type: String,
            required: false,
            default: `post`,
        },
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        tag: {
            type: String,
            required: false,
            default: `button`,
        },
        text: {
            type: String,
            required: true,
        },
        isDisableRequired: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            internalDisabled: this.disabled,
        }
    },

    methods: {
        hitApi() {
            if (this.confirm && !confirm(this.confirm)) {
                return;
            }

            this.toggleDisabled();

            let param1 = this.endPoint;
            let param2 = this.method === 'delete' ? this.config : this.params; //axios required endpoint, config, param if delete.  Other requests are endpoint, params, config - https://stackoverflow.com/questions/51069552/axios-delete-request-with-request-body-and-headers
            let param3 = this.method === 'delete' ? this.params : this.config; //axios switches params around if its a delete.  Other requests are endpoint, params, config - https://stackoverflow.com/questions/51069552/axios-delete-request-with-request-body-and-headers

            axios
                [this.method](param1, param2, param3)
                .then(response => {
                    if (Object.hasOwnProperty.call(response.data, 'code') && ![200, 202].includes(response.data.code)) {
                        this.returnError(response.message);

                        return;
                    }

                    this.$emit(`response`, response);
                    if (!this.isDisableRequired) {
                        this.toggleDisabled();
                    }
                })
                .catch(error => this.returnError(error))
            ;
        },
        returnError(error) {
            this.$emit(`error`, error);
            this.toggleDisabled();
        },
        toggleDisabled() {
            Object.assign(this, {internalDisabled: !this.internalDisabled});
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Buttons/ApiPostButton.vue